import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteUserMutation} from '../hooks/useUsersQuery';
import {useUsersSelection} from "../hooks/useUsersSelection.ts";


export const DeleteRecordButton = () => {

    const deleteUserMutation = useDeleteUserMutation();

    const {
        selection,
        handleClearSelection,
    } = useUsersSelection();

    const usernames = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = usernames.length === 0;

    const handleDelete = async () => {
        for (const username of usernames) {
            await deleteUserMutation.mutateAsync(username);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={usernames.length}
        handleConfirm={handleDelete}
    />);

};
